module.exports = __webpack_public_path__ + "img/03.ed72cf22.png";